import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query UserProfile ($id: ID!) {
      UserProfile: User(id: $id) {
        ...userProfileBig
      }
    }
    ${fragments.userProfileBig}
    ${fragments.userProfileDetail}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.companyDetail}
    ${fragments.companyArtworks}
    ${fragments.companyNameDetail}
    ${fragments.companyNames}
  `
